import { render } from "./SearchByCategorySubpage.vue?vue&type=template&id=6fcbdfed&scoped=true"
import script from "./SearchByCategorySubpage.vue?vue&type=script&lang=js"
export * from "./SearchByCategorySubpage.vue?vue&type=script&lang=js"

import "./SearchByCategorySubpage.vue?vue&type=style&index=0&id=6fcbdfed&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcbdfed"]])

export default __exports__